import React from 'react';
import { Img, ContentsContainer, FormItem } from 'components';

export interface Props {
    arrangeLicenseImage: string;
}

/** 화물 자동차 운송 주선사업 허가증 (가정이사) **/
function ArrangeLicense({ arrangeLicenseImage }: Props): React.ReactElement {
    return (
        <ContentsContainer title={'화물 자동차 운송 주선사업 허가증'}>
            <FormItem label={'화물 자동차 운송 주선사업 허가증 사진'}>
                <Img alt={'화물 자동차 운송 주선사업 허가증 사진'} src={arrangeLicenseImage} />
            </FormItem>
        </ContentsContainer>
    );
}

export default ArrangeLicense;
